function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ApiProvider from './api-provider';
var HttpClient = /*#__PURE__*/function () {
  function HttpClient() {
    _classCallCheck(this, HttpClient);
    this.baseAddress = ApiProvider.getUrl();
  }
  return _createClass(HttpClient, [{
    key: "get",
    value: function get(url) {
      var apiSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#B2BOrdersApi';
      // const fullUrl = `${this.baseAddress}${url}`;
      var fullUrl = "".concat(ApiProvider.getUrl(apiSelector)).concat(url);
      var header = ApiProvider.getAuthorizationHeader();
      var language = this.getLanguage();
      return $.ajax({
        method: 'GET',
        url: fullUrl,
        headers: {
          Authorization: header,
          Accept: 'application/json',
          'Accept-Language': language
        }
      });
    }
  }, {
    key: "getLanguage",
    value: function getLanguage() {
      var configuration = JSON.parse($('#B2BSessionDetails').text());
      return configuration.currentlanguage;
    }

    /**
     * Does a post request (defaulting to JSON data)
     * @param {string} url
     * @param {object} data
     * @param {string?} apiSelector
     * @param {string?} contentType
     * @param {string?} dataType
     */
  }, {
    key: "post",
    value: function post(url, data) {
      var apiSelector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#B2BOrdersApi';
      var contentType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'application/json';
      var dataType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'json';
      // const fullUrl = `${this.baseAddress}${url}`;
      var fullUrl = "".concat(ApiProvider.getUrl(apiSelector)).concat(url);
      var header = ApiProvider.getAuthorizationHeader();
      var language = this.getLanguage();
      return $.ajax({
        method: 'POST',
        url: fullUrl,
        data: data,
        headers: {
          Authorization: header,
          'Accept-Language': language
        },
        contentType: contentType,
        dataType: dataType
      });
    }
  }, {
    key: "getBaseurl",
    value: function getBaseurl(apiSelector) {
      return ApiProvider.getUrl(apiSelector);
    }
  }]);
}();
export default HttpClient;